import React, { useEffect, useState } from 'react';
import SearchInput from '../../components/SearchInput/SearchInput';
import Tab from '../../components/Tab/Tab';
import SwitchBox from '../../components/SwitchBox/SwitchBox';
import FlooringRatesCard from './FlooringRatesCard';
import axios from '../../axios/axios';
import { useDispatch, useSelector } from 'react-redux';
import { setFlooringRateFilter } from '../../redux/slice/dealerCommFilterSlice';
import FilterBy from '../../components/FilterBy/FilterBy';
import LoaderComp from '../../components/LoaderComp';
import { Popover } from 'antd';

const VehicleType = [
  { id: '', name: 'All' },
  { name: 'COE', id: 'COE' },
  { name: 'PARF', id: 'PARF' },
  { name: 'BODY ONLY', id: 'BODYONLY' },
];

const DefaultFilters = {
  search_key: '',
  vehicle_type: '',
  is_featured: '',
  is_scheduled: '',
  sortKey: 'agentname',
  sortOrder: 'asc',
  tabId: 0,
};

const sortOptions = [
  { label: 'Name A-Z', value: 'name_asc' },
  { label: 'Name Z-A', value: 'name_desc' },
  { label: 'Interest rate: Low - High', value: 'asc' },
  { label: 'Interest rate: High - Low', value: 'desc' },
];
const sortOptionsAll = [
  { label: 'Name A-Z', value: 'asc' },
  { label: 'Name Z-A', value: 'desc' },
];

const FlooringRates = () => {
  const accessToken = localStorage.getItem('dealerModuleToken');
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const flooringRatesFilter = useSelector(
    (state) => state?.dealerCommFilter?.flooringRateFilter
  );
  const [activeTab, setActiveTab] = useState(
    flooringRatesFilter?.tabId !== undefined &&
      flooringRatesFilter?.tabId !== ''
      ? flooringRatesFilter?.tabId
      : DefaultFilters?.tabId
  );
  const [searchValue, setSearchValue] = useState('');
  const [flooringRates, setFlooringRates] = useState([]);
  const [flooringCount, setFlooringCount] = useState({});
  const [applyFilters, setApplyFilters] = useState(
    flooringRatesFilter && Object.keys(flooringRatesFilter).length > 0
      ? { ...DefaultFilters, ...flooringRatesFilter }
      : DefaultFilters
  );
  const [sortByValue, setSortByValue] = useState(applyFilters?.sortOrder);
  const [floorRateSortOprions, setFloorRateSortOptions] = useState(
    applyFilters?.vehicle_type === '' ? sortOptionsAll : sortOptions
  );

  const tabs = [
    `All Flooring Rates (${flooringCount.flooring_rates_count})`,
    `Featured (${flooringCount.featured_count})`,
    `Scheduled (${flooringCount?.scheduled_count})`,
  ];

  const HandleFilters = (key, value) => {
    setApplyFilters({
      ...applyFilters,
      ...key,
    });
    dispatch(
      setFlooringRateFilter({
        ...applyFilters,
        ...key,
      })
    );
  };

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
    HandleFilters({ search_key: e.target.value });
  };

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
    if (tabIndex == 2) {
      HandleFilters({ is_featured: '', is_scheduled: 1, tabId: tabIndex });
    } else if (tabIndex == 1) {
      HandleFilters({ is_featured: 1, is_scheduled: '', tabId: tabIndex });
    } else {
      HandleFilters({ is_featured: '', is_scheduled: '', tabId: tabIndex });
    }
    // You can perform any other actions you need when a tab is changed here
  };

  const handleSettingsChange = (idx, title, tabId) => {
    if (tabId === '') {
      setFloorRateSortOptions(sortOptionsAll);
      HandleFilters({
        sortKey: 'agentname',
        sortOrder: 'asc',
        vehicle_type: tabId,
      });
      setSortByValue('asc');
    } else {
      setFloorRateSortOptions(sortOptions);
      HandleFilters({
        sortKey: applyFilters?.sortKey?.includes('interest')
          ? applyFilters?.sortKey
          : 'agentname',
        sortOrder: applyFilters?.sortKey?.includes('interest')
          ? applyFilters?.sortOrder
          : 'name_asc',
        vehicle_type: tabId,
      });
      setSortByValue(
        applyFilters?.sortKey?.includes('interest')
          ? applyFilters?.sortOrder
          : 'name_asc'
      );
    }
  };

  const GetFlooringRates = async () => {
    setLoading(true);
    const resp = await axios.post(
      '/flooring/product',
      {
        ...applyFilters,
        sortOrder: applyFilters?.sortOrder?.includes('name')
          ? applyFilters?.sortOrder?.slice(
              applyFilters?.sortOrder.indexOf('_') + 1,
              applyFilters?.sortOrder.length
            )
          : applyFilters?.sortOrder,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (resp.status < 400) {
      setFlooringRates(resp.data?.data?.agents);
      setFlooringCount(resp.data?.data?.count);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };
  useEffect(() => {
    GetFlooringRates();
  }, [applyFilters]);

  const handleSortBy = (label, value) => {
    setSortByValue(value);
    if (label === 'Interest rate: High - Low') {
      HandleFilters({ sortKey: 'interest_to', sortOrder: value });
    } else if (label === 'Interest rate: Low - High') {
      HandleFilters({ sortKey: 'interest_from', sortOrder: value });
    } else {
      HandleFilters({
        sortKey: 'agentname',
        sortOrder: value?.includes('name')
          ? value?.slice(value.indexOf('_') + 1, value.length)
          : value,
      });
    }
  };


  return (
    <section className='common_container'>
      <header className='common-header flex justify-between'>
        <div className='common-header-body'>
          <h1>Flooring Rates</h1>
        </div>
        <SearchInput onChange={handleSearchChange} value={searchValue} />
      </header>
      <section>
        <div className='tab-section'>
          <Tab
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
        </div>
        <section className='switch-box-section with-sortby'>
          <div>
            <SwitchBox
              title='Vehicle Type'
              tabs={VehicleType}
              settingsHandle={handleSettingsChange}
              value={applyFilters?.vehicle_type}
            />
          </div>
          <div style={{ display: 'flex' }}>
            <FilterBy
              sortOptions={floorRateSortOprions}
              value={sortByValue}
              handleSortBy={handleSortBy}
              //isDisabled={applyFilters?.vehicle_type == ""}
            />
            {applyFilters?.vehicle_type === '' && (
              <Popover
                content={
                  'Swicth to particluar vehicle type to sort by their interest %'
                }
              >
                <img
                  src='/images/fi_info.svg'
                  alt='info'
                  className='inline-block ml-[4px] cursor-pointer'
                />
              </Popover>
            )}
          </div>
        </section>
        {loading ? (
          <div className='tab-body-section'>
            <LoaderComp />
          </div>
        ) : (
          <div className='tab-body-section'>
            {activeTab === 0 && (
              <FlooringRatesCard
                flooringRates={flooringRates}
                activeTab={activeTab}
              />
            )}
            {activeTab === 1 && (
              <FlooringRatesCard
                flooringRates={flooringRates}
                activeTab={activeTab}
              />
            )}
            {activeTab === 2 && (
              <FlooringRatesCard
                flooringRates={flooringRates}
                activeTab={activeTab}
              />
            )}
          </div>
        )}
      </section>
    </section>
  );
};

export default FlooringRates;
